(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("22cn8", function(module, exports) {

$parcel$export(module.exports, "getFilterFromQueryParams", function () { return $3a2a085f4d14c4e3$export$e21ccb11fb11305c; });
$parcel$export(module.exports, "filterToQuerystring", function () { return $3a2a085f4d14c4e3$export$81fb3fd77062e5ad; });
$parcel$export(module.exports, "FilterContext", function () { return $3a2a085f4d14c4e3$export$152247e07967bd8f; });
$parcel$export(module.exports, "getFilterFromPath", function () { return $3a2a085f4d14c4e3$export$3f6d48775dbb7b16; });

var $cUbQm = parcelRequire("cUbQm");

var $l8eky = parcelRequire("l8eky");

var $515ZP = parcelRequire("515ZP");

var $5J7FU = parcelRequire("5J7FU");

var $dTCkE = parcelRequire("dTCkE");
async function $3a2a085f4d14c4e3$export$e21ccb11fb11305c() {
    const tags = [];
    const params = new URLSearchParams(window.location.search);
    // estate types
    const estateTypeParam = params.get((0, $cUbQm.FilterParams).ESTATETYPE_PARAM);
    estateTypeParam?.split(",").forEach((estateType)=>{
        tags.push({
            type: "estateType",
            estateType: estateType
        });
    });
    const municiParam = params.get((0, $cUbQm.FilterParams).MUNICI_PARAM);
    municiParam?.split(",").forEach((municipality)=>{
        tags.push({
            type: "munici",
            id: municipality,
            label: `${municipality} (Kommun)`
        });
    });
    const countyParam = params.get((0, $cUbQm.FilterParams).COUNTY_PARAM);
    countyParam?.split(",").forEach((county)=>{
        tags.push({
            type: "county",
            id: county,
            label: `${county} (L\xe4n)`
        });
    });
    const areaParam = params.get((0, $cUbQm.FilterParams).AREA_PARAM);
    const areaNames = params.get("areaNames")?.split(",");
    areaParam?.split(",").forEach((area, i)=>{
        const areaNameFromQP = areaNames?.[i] ?? "";
        tags.push({
            type: "area",
            id: area,
            label: `${areaNameFromQP ? areaNameFromQP : area} (Omr\xe5de)`
        });
    });
    //this is done to set button when page is reloaded
    const polyParam = params.get((0, $cUbQm.FilterParams).POLYGON_PARAM);
    if (polyParam !== null) tags.push({
        type: (0, $cUbQm.FilterParams).POLYGON_PARAM,
        label: "Ritat omr\xe5de",
        polygons: polyParam.toString()
    });
    // extra criterias
    const extraCriteriaParam = params.get((0, $cUbQm.FilterParams).EXTRACRITERIA_PARAM);
    extraCriteriaParam?.split(",").forEach((id)=>{
        const criteriaName = getExtraSearchCriteriaName(id);
        tags.push({
            type: "extraCriteria",
            id: id,
            text: criteriaName
        });
    });
    function getExtraSearchCriteriaName(id) {
        const criteriaResp = (0, $cUbQm.ExtraCriterias)[id];
        const criteriaName = criteriaResp?.text;
        return criteriaName;
    }
    // showOnlyHeadStart
    const fromheadStartQuery = params.get((0, $cUbQm.FilterParams).HEADSTART_PARAM);
    if (fromheadStartQuery !== null && ((0, $cUbQm.FilterParams).BROKERID_PARAM !== null || (0, $cUbQm.FilterParams).CUSTOMERID_PARAM !== null)) {
        const fromheadStartParam = fromheadStartQuery === "true" ? true : false;
        tags.push({
            type: (0, $cUbQm.FilterParams).HEADSTART_PARAM,
            isChecked: fromheadStartParam
        });
    }
    // showSold
    const fromSoldQuery = params.get((0, $cUbQm.FilterParams).SOLD_PARAM);
    if (fromSoldQuery !== null && ((0, $cUbQm.FilterParams).BROKERID_PARAM !== null || (0, $cUbQm.FilterParams).CUSTOMERID_PARAM !== null)) {
        const soldParam = fromSoldQuery === "true" ? true : false;
        tags.push({
            type: (0, $cUbQm.FilterParams).SOLD_PARAM,
            isChecked: soldParam
        });
    }
    // alignment
    const alignmentsParam = params.get((0, $cUbQm.FilterParams).ALIGNMENT_PARAM);
    alignmentsParam?.split(",").forEach((id)=>{
        id = id.replace("/", "-");
        tags.push({
            type: "alignment",
            id: id
        });
    });
    //Broker param from offices
    const brokerParam = params.get((0, $cUbQm.FilterParams).BROKERID_PARAM);
    if (brokerParam !== null) {
        const brokerName = await (0, $515ZP.getBrokerName)(brokerParam);
        if (brokerName !== undefined) tags.push({
            type: "broker",
            id: brokerParam,
            label: brokerName
        });
    }
    //Office id from officepage
    const officeParam = params.get((0, $cUbQm.FilterParams).CUSTOMERID_PARAM);
    if (officeParam !== null) {
        const officeName = await (0, $515ZP.getOfficeName)(officeParam);
        tags.push({
            type: "office",
            id: officeParam,
            label: officeName
        });
    }
    //Sustainable choice
    const greenEstateParam = params.get((0, $cUbQm.FilterParams).GREENESTATES_PARAM);
    if (greenEstateParam !== null) tags.push({
        type: (0, $cUbQm.FilterParams).GREENESTATES_PARAM,
        label: (0, $cUbQm.ServicesTitles).GreenEstate,
        isChecked: greenEstateParam === "true" ? true : false
    });
    //Bidding
    const biddingParam = params.get((0, $cUbQm.FilterParams).BIDDING_PARAM);
    if (biddingParam !== null) tags.push({
        type: (0, $cUbQm.FilterParams).BIDDING_PARAM,
        label: (0, $5J7FU.ForSaleStrings).BiddingShort,
        isChecked: biddingParam === "true" ? true : false
    });
    //sorting
    const sortParam = params.get((0, $cUbQm.FilterParams).SORT_PARAM);
    if (sortParam !== null) tags.push({
        type: "sortType",
        id: sortParam,
        name: (0, $cUbQm.SortType)[parseInt(sortParam)].label
    });
    // price
    if (params.get((0, $cUbQm.FilterParams).PRICEMIN_PARAM) !== null && params.get((0, $cUbQm.FilterParams).PRICEMAX_PARAM) !== null) {
        const priceMinParam = Number(params.get((0, $cUbQm.FilterParams).PRICEMIN_PARAM));
        const priceMaxParam = Number(params.get((0, $cUbQm.FilterParams).PRICEMAX_PARAM));
        tags.push({
            type: "rangeTag",
            name: (0, $cUbQm.RangeTagNames).Price,
            minVal: priceMinParam,
            maxVal: priceMaxParam
        });
    }
    // rooms
    if (params.get((0, $cUbQm.FilterParams).ROOMMIN_PARAM) !== null && params.get((0, $cUbQm.FilterParams).ROOMMAX_PARAM) !== null) {
        const roomMinParam = Number(params.get((0, $cUbQm.FilterParams).ROOMMIN_PARAM));
        const roomMaxParam = Number(params.get((0, $cUbQm.FilterParams).ROOMMAX_PARAM));
        tags.push({
            type: "rangeTag",
            name: (0, $cUbQm.RangeTagNames).Room,
            minVal: roomMinParam,
            maxVal: roomMaxParam
        });
    }
    // livingspace
    if (params.get((0, $cUbQm.FilterParams).LIVINGSPACEMIN_PARAM) !== null && params.get((0, $cUbQm.FilterParams).LIVINGSPACEMAX_PARAM) !== null) {
        const livingSpaceMinParam = Number(params.get((0, $cUbQm.FilterParams).LIVINGSPACEMIN_PARAM));
        const livingSpaceMaxParam = Number(params.get((0, $cUbQm.FilterParams).LIVINGSPACEMAX_PARAM));
        tags.push({
            type: "rangeTag",
            name: (0, $cUbQm.RangeTagNames).LivingSpace,
            minVal: livingSpaceMinParam,
            maxVal: livingSpaceMaxParam
        });
    }
    // monthly cost
    if (params.get((0, $cUbQm.FilterParams).MONTHLYCOSTMIN_PARAM) !== null && params.get((0, $cUbQm.FilterParams).MONTHLYCOSTMAX_PARAM) !== null) {
        const monthlyCostMinParam = Number(params.get((0, $cUbQm.FilterParams).MONTHLYCOSTMIN_PARAM));
        const monthlyCostMaxParam = Number(params.get((0, $cUbQm.FilterParams).MONTHLYCOSTMAX_PARAM));
        tags.push({
            type: "rangeTag",
            name: (0, $cUbQm.RangeTagNames).Charge,
            minVal: monthlyCostMinParam,
            maxVal: monthlyCostMaxParam
        });
    }
    // plotarea
    if (params.get((0, $cUbQm.FilterParams).PLOTAREAMIN_PARAM) !== null && params.get((0, $cUbQm.FilterParams).PLOTAREAMAX_PARAM) !== null) {
        const plotAreaMinParam = Number(params.get((0, $cUbQm.FilterParams).PLOTAREAMIN_PARAM));
        const plotAreaMaxParam = Number(params.get((0, $cUbQm.FilterParams).PLOTAREAMAX_PARAM));
        tags.push({
            type: "rangeTag",
            name: (0, $cUbQm.RangeTagNames).PlotArea,
            minVal: plotAreaMinParam,
            maxVal: plotAreaMaxParam
        });
    }
    return tags;
}
function $3a2a085f4d14c4e3$export$81fb3fd77062e5ad(filter, page, myPagesCheck) {
    const filtersStrings = [];
    // page
    if (page != null) filtersStrings.push(`page=${page}`);
    //municipality
    if (filter.some((x)=>x.type === "munici" && !myPagesCheck)) filtersStrings.push(`${(0, $cUbQm.FilterParams).MUNICI_PARAM}=${filter.filter((x)=>x.type === "munici").map((x)=>x.id).join(",")}`);
    else if (filter.some((x)=>x.type === "munici" && myPagesCheck)) filtersStrings.push(`${(0, $cUbQm.FilterParams).MUNICI_PARAM}=${filter.filter((x)=>x.type === "munici").map((x)=>x.municipality).join(",")}`);
    //county
    if (filter.some((x)=>x.type === "county")) filtersStrings.push(`${(0, $cUbQm.FilterParams).COUNTY_PARAM}=${filter.filter((x)=>x.type === "county").map((x)=>x.id).join(",")}`);
    //area
    if (filter.some((x)=>x.type === "area")) {
        filtersStrings.push(`${(0, $cUbQm.FilterParams).AREA_PARAM}=${filter.filter((x)=>x.type === "area").map((x)=>x.id).join(",")}`);
        filtersStrings.push(`${"areaNames"}=${filter.filter((x)=>x.type === "area").map((x)=>x.label?.split(" (")[0]).join(",")}`);
    }
    // estate types
    if (filter.some((x)=>x.type === "estateType")) filtersStrings.push(`${(0, $cUbQm.FilterParams).ESTATETYPE_PARAM}=${filter.filter((x)=>x.type === "estateType").map((x)=>x.estateType).join(",")}`);
    // extra criterias
    if (filter.some((x)=>x.type === "extraCriteria")) filtersStrings.push(`${(0, $cUbQm.FilterParams).EXTRACRITERIA_PARAM}=${filter.filter((x)=>x.type === "extraCriteria").map((x)=>x.id).join(",")}`);
    // alignment
    if (filter.some((x)=>x.type === "alignment")) filtersStrings.push(`${(0, $cUbQm.FilterParams).ALIGNMENT_PARAM}=${filter.filter((x)=>x.type === "alignment").map((x)=>x.id).join(",")}`);
    if (filter.some((x)=>x.type === "broker")) filtersStrings.push(`${(0, $cUbQm.FilterParams).BROKERID_PARAM}=${filter.filter((x)=>x.type === "broker").map((x)=>x.id)}`);
    if (filter.some((x)=>x.type === "office")) filtersStrings.push(`${(0, $cUbQm.FilterParams).CUSTOMERID_PARAM}=${filter.filter((x)=>x.type === "office").map((x)=>x.id)}`);
    //Försprång
    if (filter.some((x)=>x.type === (0, $cUbQm.FilterParams).HEADSTART_PARAM)) filtersStrings.push(`${(0, $cUbQm.FilterParams).HEADSTART_PARAM}=${filter.filter((x)=>x.type === (0, $cUbQm.FilterParams).HEADSTART_PARAM).map((x)=>x.isChecked)}`);
    //Only show sold
    if (filter.some((x)=>x.type === (0, $cUbQm.FilterParams).SOLD_PARAM)) filtersStrings.push(`${(0, $cUbQm.FilterParams).SOLD_PARAM}=${filter.filter((x)=>x.type === (0, $cUbQm.FilterParams).SOLD_PARAM).map((x)=>x.isChecked)}`);
    //Sustainable choice
    if (filter.some((x)=>x.type === (0, $cUbQm.FilterParams).GREENESTATES_PARAM)) filtersStrings.push(`${(0, $cUbQm.FilterParams).GREENESTATES_PARAM}=${filter.filter((x)=>x.type === (0, $cUbQm.FilterParams).GREENESTATES_PARAM).map((x)=>x.isChecked)}`);
    //Bidding
    if (filter.some((x)=>x.type === (0, $cUbQm.FilterParams).BIDDING_PARAM)) filtersStrings.push(`${(0, $cUbQm.FilterParams).BIDDING_PARAM}=${filter.filter((x)=>x.type === (0, $cUbQm.FilterParams).BIDDING_PARAM).map((x)=>x.isChecked)}`);
    // price
    if (filter.some((x)=>x.type === "rangeTag" && x.name === "Pris")) filtersStrings.push(`${(0, $cUbQm.FilterParams).PRICEMIN_PARAM}=${filter.filter((x)=>x.type === "rangeTag" && x.name === "Pris").map((x)=>x.minVal).join(",")}`);
    if (filter.some((x)=>x.type === "rangeTag" && x.name === "Pris")) filtersStrings.push(`${(0, $cUbQm.FilterParams).PRICEMAX_PARAM}=${filter.filter((x)=>x.type === "rangeTag" && x.name === "Pris").map((x)=>x.maxVal).join(",")}`);
    //rooms
    if (filter.some((x)=>x.type === "rangeTag" && x.name === "Rum")) filtersStrings.push(`${(0, $cUbQm.FilterParams).ROOMMIN_PARAM}=${filter.filter((x)=>x.type === "rangeTag" && x.name === "Rum").map((x)=>x.minVal).join(",")}`);
    if (filter.some((x)=>x.type === "rangeTag" && x.name === "Rum")) filtersStrings.push(`${(0, $cUbQm.FilterParams).ROOMMAX_PARAM}=${filter.filter((x)=>x.type === "rangeTag" && x.name === "Rum").map((x)=>x.maxVal).join(",")}`);
    // livingspace
    if (filter.some((x)=>x.type === "rangeTag" && x.name === "Boarea")) filtersStrings.push(`${(0, $cUbQm.FilterParams).LIVINGSPACEMIN_PARAM}=${filter.filter((x)=>x.type === "rangeTag" && x.name === "Boarea").map((x)=>x.minVal).join(",")}`);
    if (filter.some((x)=>x.type === "rangeTag" && x.name === "Boarea")) filtersStrings.push(`${(0, $cUbQm.FilterParams).LIVINGSPACEMAX_PARAM}=${filter.filter((x)=>x.type === "rangeTag" && x.name === "Boarea").map((x)=>x.maxVal).join(",")}`);
    // Monthly cost
    if (filter.some((x)=>x.type === "rangeTag" && x.name === "Avgift")) filtersStrings.push(`${(0, $cUbQm.FilterParams).MONTHLYCOSTMIN_PARAM}=${filter.filter((x)=>x.type === "rangeTag" && x.name === "Avgift").map((x)=>x.minVal).join(",")}`);
    if (filter.some((x)=>x.type === "rangeTag" && x.name === "Avgift")) filtersStrings.push(`${(0, $cUbQm.FilterParams).MONTHLYCOSTMAX_PARAM}=${filter.filter((x)=>x.type === "rangeTag" && x.name === "Avgift").map((x)=>x.maxVal).join(",")}`);
    // Plot Area
    if (filter.some((x)=>x.type === "rangeTag" && x.name === "Tomtarea")) filtersStrings.push(`${(0, $cUbQm.FilterParams).PLOTAREAMIN_PARAM}=${filter.filter((x)=>x.type === "rangeTag" && x.name === "Tomtarea").map((x)=>x.minVal).join(",")}`);
    if (filter.some((x)=>x.type === "rangeTag" && x.name === "Tomtarea")) filtersStrings.push(`${(0, $cUbQm.FilterParams).PLOTAREAMAX_PARAM}=${filter.filter((x)=>x.type === "rangeTag" && x.name === "Tomtarea").map((x)=>x.maxVal).join(",")}`);
    if (filter.some((x)=>x.type === "polygons")) filtersStrings.push(`${(0, $cUbQm.FilterParams).POLYGON_PARAM}=${filter.filter((x)=>x.type === "polygons").map((x)=>x.polygons.toString()).join(",")}`);
    // sortType
    if (filter.some((x)=>x.type === "sortType")) filtersStrings.push(`${(0, $cUbQm.FilterParams).SORT_PARAM}=${filter.filter((x)=>x.type === "sortType").map((x)=>x.id)}`);
    return filtersStrings.length ? encodeURI(`?${filtersStrings.join("&")}`) : "";
}
const $3a2a085f4d14c4e3$export$152247e07967bd8f = /*#__PURE__*/ (0, $dTCkE.createContext)({});
async function $3a2a085f4d14c4e3$export$3f6d48775dbb7b16(path) {
    const tags = [];
    if (path.area) {
        const cameledArea = (0, $l8eky.makeCamelCase)(path.area);
        const withoutDashes = cameledArea.replace(/-/g, " ");
        tags.push({
            type: "area",
            id: cameledArea,
            label: `${withoutDashes} (Omr\xe5de)`
        });
    } else if (path.muni) {
        const cameledMunici = (0, $l8eky.makeCamelCase)(path.muni);
        const municipality = (0, $l8eky.makeCamelCase)(await (0, $515ZP.getMunicipalityTag)(cameledMunici));
        if (municipality !== undefined) tags.push({
            type: "munici",
            id: cameledMunici,
            label: `${municipality}`
        });
    } else if (path.county) {
        const cameledCounty = (0, $l8eky.makeCamelCase)(path.county);
        const county = (0, $l8eky.makeCamelCase)(await (0, $515ZP.getCountyTag)(cameledCounty));
        if (county !== undefined) tags.push({
            type: "county",
            id: cameledCounty,
            label: `${county}`
        });
    }
    if (path.estateType && path.estateType !== "bostad" && path.estateType !== "bra-energiklass") {
        let tempHolder = "";
        let prettyEstateTypeName = path.estateType;
        //ordinary cases
        if (path.estateType === "bostadsratt") {
            tempHolder = path.estateType;
            prettyEstateTypeName = $3a2a085f4d14c4e3$var$replaceAt(tempHolder, 8, "\xe4");
        } else if (path.estateType === "gard") {
            tempHolder = path.estateType;
            prettyEstateTypeName = $3a2a085f4d14c4e3$var$replaceAt(tempHolder, 1, "\xe5");
        }
        const withoutDashes = prettyEstateTypeName.replace(/-/g, " ");
        const cameledEstateType = (0, $l8eky.makeCamelCase)(withoutDashes);
        tags.push({
            type: "estateType",
            estateType: cameledEstateType
        });
    } else if (path.estateType && path.estateType === "bra-energiklass") tags.push({
        type: (0, $cUbQm.FilterTypes).ShowGreenEstates,
        isChecked: true,
        label: (0, $cUbQm.ServicesTitles).GreenEstate
    });
    return tags;
}
function $3a2a085f4d14c4e3$var$replaceAt(myString, index, replacement) {
    return myString.substr(0, index) + replacement + myString.substr(index + replacement.length);
}

});

})();
//# sourceMappingURL=SoldObjectSearchProfile.6842f8a2.js.map
